import { z, toJSONSchema } from 'zod';
import Cookies from 'js-cookie';
import { TENANT_STORAGE_KEY } from '@constants/tenant';
import { useServiceRef } from 'hooks/useServiceRef';
import { CheckoutService } from '@services/checkout';
import { AuthorizationService } from '@services/auth';
import { InputSchema, ToolDescriptor, ToolResponse } from '@mcp-b/webmcp-types';

export const getOrderHistoryTool: ToolDescriptor<Record<string, unknown>, ToolResponse> = {
  name: 'get_order_history',
  description: 'Get the current user\'s order history.',
  inputSchema: toJSONSchema(z.object({})) as InputSchema,
  execute: async (): Promise<ToolResponse> => {
    const checkoutServiceRef = useServiceRef(CheckoutService);
    const authorizationServiceRef = useServiceRef(AuthorizationService);

    const customer = await authorizationServiceRef.current.getSignedInCustomer();

    if (!customer?.id) {
      return {
        content: [ {
          type: 'text',
          text: 'Unauthorized',
        } ]
      };
    }

    const currentTenantKey = JSON.parse(Cookies.get(TENANT_STORAGE_KEY)|| null)?.key;
    const orders = await checkoutServiceRef.current.getMyOrders(currentTenantKey);

    return {
      content: [ {
        type: 'text',
        text: `Found ${orders?.length || 0} orders. Orders: ${JSON.stringify(orders)}.`,
      } ]
    };
  }
};
